import { useEffect, useState } from 'react';
import { getSgConnectToken, getUserInfo, IUserInfo } from 'services/auth/sg-connect';
import { configuration } from 'config/constants';


export const initUserInfo = async () => {
  const user = window.SGWTWidgetConfiguration?.bus?.dangerouslyGetCurrentValue('sg-connect.user-info');
  const token = await getSgConnectToken();
  if (user || !token) {
    return;
  }
  window.SGWTWidgetConfiguration?.bus?.publish('sg-connect.user-info', {});

  const url = `${configuration.sgConnect.endpoint}/oauth2/userinfo`;

  console.log(`Getting UserInfo from "${url}"`);

  fetch(url, {
    headers: {
      accept: 'application/json',
      authorization: token,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then(response => response.json())
    .then(data => {
      window.SGWTWidgetConfiguration?.bus?.publish('sg-connect.user-info', data);
    })
    .catch((error) => console.error(error));
};

export const useUser = () => {
  const [user, setUser] = useState<IUserInfo | undefined | null>(null);

  useEffect(() => {
    (async () => {
      const user = await getUserInfo();
      setUser(user);
    })();
  }, []);

  return {
    user,
    contactId: user?.contact_id,
    isInternal: user?.is_sg_group_user?.toLowerCase() === 'true',
    existsInPops: !!user?.igg,
  };
};